"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CustomDataPropType = exports.PlaceholderPropType = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _CustomDataWrapper = _interopRequireDefault(require("./CustomDataWrapper"));

var _CustomDataHelperText = _interopRequireDefault(require("./CustomDataHelperText"));

// TODO: Refactor usages on TemplateMessageEditor
var PlaceholderPropType = _propTypes["default"].shape({
  value: _propTypes["default"].string,
  label: _propTypes["default"].string,
  placeholder: _propTypes["default"].string
});

exports.PlaceholderPropType = PlaceholderPropType;

var CustomDataPropType = _propTypes["default"].arrayOf(PlaceholderPropType);

exports.CustomDataPropType = CustomDataPropType;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    controls: {
      display: 'inline-block'
    },
    insertLink: {
      cursor: 'pointer',
      paddingRight: 2,
      position: 'relative',
      top: 14,
      paddingBottom: theme.spacing(1)
    }
  };
});
/**
 * @callback onCustomDataChange
 * @param {string} value
 * @returns {undefined}
 */

/**
 * CustomDataEditor.
 *
 * @deprecated Use TemplateMessageEditor.
 *
 * @param {object} props
 * @param {string} props.message
 * @param {Array<{ value: ?string, label: string, property: string }>} props.customData
 * @param {onCustomDataChange} props.onChange
 * @param {Array<string>} [props.errors=[]]
 * @param {boolean} [props.disabled=false]
 * @param {number} [props.charsLimit]
 * @param {object} [props.textFieldProps={}]
 * @param {object} [props.insertDataButtonProps={}]
 * @returns {React.ReactNode}
 *
 * @example
 * //TODO: Write example.
 */

var CustomDataEditor = function CustomDataEditor(_ref) {
  var message = _ref.message,
      customData = _ref.customData,
      _onChange = _ref.onChange,
      errors = _ref.errors,
      disabled = _ref.disabled,
      charsLimit = _ref.charsLimit,
      textFieldProps = _ref.textFieldProps,
      insertDataButtonProps = _ref.insertDataButtonProps;
  var classes = useStyles();
  var editorRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      customDataWrapperOpened = _useState2[0],
      setCustomDataWrapperOpened = _useState2[1];
  /**
   * Insert custom data into input selection.
   *
   * @param {string} customDataText
   */


  var onInsertCustomData = function onInsertCustomData(customDataText) {
    var _editorRef$current = editorRef.current,
        selectionStart = _editorRef$current.selectionStart,
        selectionEnd = _editorRef$current.selectionEnd;
    var firstPart = editorRef.current.value.substring(0, selectionStart);
    var lastPart = editorRef.current.value.slice(selectionEnd, editorRef.current.value.length);
    setCustomDataWrapperOpened(false);

    _onChange(firstPart + customDataText + lastPart); // need timeout here, cause of async nature of setState


    setTimeout(function (editor) {
      return function () {
        Object.assign(editor, {
          selectionStart: selectionStart + customDataText.length,
          selectionEnd: selectionStart + customDataText.length
        });
        editor.focus();
      };
    }(editorRef.current), 1);
  };

  var hasErrors = (0, _react.useMemo)(function () {
    return errors && errors.length > 0;
  }, [errors]);
  var messageErrors = (0, _react.useMemo)(function () {
    return hasErrors ? errors : [];
  }, [errors, hasErrors]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    alignItems: "center",
    justifyContent: "flex-end",
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, (0, _extends2["default"])({}, insertDataButtonProps, {
    onClick: function onClick() {
      setCustomDataWrapperOpened(!customDataWrapperOpened);
      editorRef.current.focus();
    },
    className: (0, _classnames["default"])(classes.insertLink, 'Body-Small-Link')
  }), "+Insert custom data"), customDataWrapperOpened && /*#__PURE__*/_react["default"].createElement(_material.Fade, {
    "in": true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      zIndex: 3
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.ClickAwayListener, {
    onClickAway: function onClickAway() {
      setCustomDataWrapperOpened(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_CustomDataWrapper["default"], {
    customData: customData,
    onInsertCustomData: onInsertCustomData
  }))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.editorWrapper
  }, /*#__PURE__*/_react["default"].createElement(_material.TextField, (0, _extends2["default"])({
    fullWidth: true,
    multiline: true,
    error: hasErrors,
    helperText: /*#__PURE__*/_react["default"].createElement(_CustomDataHelperText["default"], {
      leftCharsMessage: "".concat(message.length, "/").concat(charsLimit, " characters"),
      errors: messageErrors
    }),
    label: "Your message",
    variant: "outlined",
    margin: "normal",
    value: message,
    disabled: disabled,
    onChange: function onChange(e) {
      _onChange(e.target.value);
    },
    inputRef: editorRef,
    FormHelperTextProps: {
      component: 'div'
    }
  }, textFieldProps))));
};

CustomDataEditor.propTypes = {
  message: _propTypes["default"].string,
  customData: CustomDataPropType,
  onChange: _propTypes["default"].func.isRequired,
  disabled: _propTypes["default"].bool,
  errors: _propTypes["default"].arrayOf(_propTypes["default"].string),
  charsLimit: _propTypes["default"].number.isRequired,
  insertDataButtonProps: _propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])),
  // eslint-disable-next-line react/forbid-prop-types
  textFieldProps: _propTypes["default"].object
};
CustomDataEditor.defaultProps = {
  message: '',
  customData: [],
  disabled: false,
  errors: [],
  textFieldProps: {},
  insertDataButtonProps: {}
};

var _default = /*#__PURE__*/_react["default"].memo(CustomDataEditor);

exports["default"] = _default;